// src/pages/checkout/PaymentPage.jsx
import React from "react";
import { Paper, RadioGroup, FormControlLabel, Radio, TextField, Typography, Stack, Button } from "@mui/material";
import { useCheckout } from "./CheckoutContext";
import { useNavigate } from "react-router-dom";

export default function PaymentPage() {
  const { payment, setPayment } = useCheckout();
  const navigate = useNavigate();

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>付款方式</Typography>
      <RadioGroup
        value={payment.method}
        onChange={(e) => setPayment(p => ({ ...p, method: e.target.value }))}
      >
        <FormControlLabel value="card" control={<Radio />} label="信用卡" />
        <FormControlLabel value="cod"  control={<Radio />} label="貨到付款" />
        <FormControlLabel value="bank" control={<Radio />} label="銀行轉帳" />
      </RadioGroup>

      {payment.method === "card" && (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 2 }}>
          <TextField label="卡號後四碼" value={payment.cardLast4}
            onChange={(e) => setPayment(p => ({ ...p, cardLast4: e.target.value }))} />
          <TextField fullWidth label="備註" value={payment.note}
            onChange={(e) => setPayment(p => ({ ...p, note: e.target.value }))} />
        </Stack>
      )}
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/checkout/confirm")}
        // disabled={cartItems.length === 0}
        sx={{ alignSelf: "flex-end" }}
      >
        確認
      </Button>
    </Paper>
  );
}
